module.exports = __webpack_public_path__ + "static/media/no-coach@3x.897a5c68.png";